'use strict';

import React, { Component } from 'react';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

import '../../../../../App.css';

const rendererLocaleName = (loc) => {
    return (loc.PARENT_NAME_SIDO ? loc.PARENT_NAME_SIDO + ' ' + (loc.PARENT_NAME_SIGUNGU ? loc.PARENT_NAME_SIGUNGU + ' ' : '') : '') + loc.NAME;
}

const rateCellRenderer = (value, rate) => {
    var html = "<div class='row'>"
    html = "<div class='text-right' style='width:50px; display: inline-block;'>" + value.toLocaleString() + "</div>"
    if (rate == 0) {
        html += "<div class='text-right text-primary' style='width:20px; display: inline-block;'></div>"
        html += "<div class='text-left text-primary' style='width:50px; display: inline-block;'></div>";
    } else if (rate < 0) {
        html += "<div class='text-right text-danger' style='width:20px; display: inline-block;'><i class='fa fa-fw fa-arrow-down'></i></div>"
        html += "<div class='text-left text-danger' style='width:50px; display: inline-block;'>" + rate + '%</div>';
    } else {
        html += "<div class='text-right text-success' style='width:20px; display: inline-block;'><i class='fa fa-fw fa-arrow-up'></i></div>"
        html += "<div class='text-left text-success' style='width:50px; display: inline-block;'>" + rate + '%</div>';
    }
    html += "</div>"

    return html;
}

const progressCellRenderer = (value, rate) => {
	var html = "";
    
    html+= '<div>'
    html+= "    <div class='progress-title' style='text-align : center'>" + value + "</div>"
    html+= '    <div class="progress progress-lg text-center" style="background:#8c8c8c;">'
    html+= '        <span class="progress-value">' + rate + '%</span>'
    html+= '        <div class="progress-bar" role="progressbar" style="width: ' + rate + '%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"/>'
    html+= '    </div>'
    html+= '</div>'
    
	return html;
}

const progressWithGrowthCellRenderer = (value, rate, growth) => {
	var html = "";
    
    html+= '<div>'
    html+= '    <div class="row progress-title">'
    html+= '        <div class="col-8" style="padding-right:0px">'
    html+= "            <div style='text-align : center'>" + value + "</div>"
    html+= '        </div>'
    html+= '        <div class="col-4 text-left" style="padding-left:0px">'
    if(growth == 0) {
		html += '       <span class="text-info" style="font-size:10px;"><i class="fa fa-fw fa-arrow-right"></i>' + growth + '%</span>';
    } else if(growth > 0) {
		html += '       <span class="text-primary" style="font-size:10px;"><i class="fa fa-fw fa-arrow-up"></i>' + growth + '%</span>';
    } else {
		html += '       <span class="text-danger" style="font-size:10px;"><i class="fa fa-fw fa-arrow-down"></i>'+ (growth * -1) + '%</span>';
    }
    html+= '        </div>'
    html+= '    </div>'
    html+= '    <div class="progress progress-lg text-center" style="background:#8c8c8c;">'
    html+= '        <span class="progress-value">' + rate + '%</span>'
    html+= '        <div class="progress-bar" role="progressbar" style="width: ' + rate + '%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"/>'
    html+= '    </div>'
    html+= '</div>'
    
	return html;
}
class LocaleList extends Component {

    constructor(props) {
        super(props);
        this.state = {
			year : this.props.year,
            loc_infos: null,
            tableData: null,
            keyword : null,
        }
    }
    gridApi = null
    gridColumnApi = null
    
    componentWillReceiveProps = (nextProps) => {
        if(this.state.year === nextProps.year && this.state.tableData !== null)
            return

        this.setState({
            year: nextProps.year,
            loc_infos : nextProps.loc_infos,
            tableData: null,
        }, () => {
        	this.setState({tableData: this.listSearch(this.state.keyword)})
        })
    }
    
	listSearch = (keyword) => {
		var list = this.state.loc_infos;
        var tableData = [];
		if(!keyword) {
            tableData = list;
		} else {
			list.map(item => {
                if ((item.NAME && item.NAME.indexOf(keyword) >= 0) 
                    || (item.PARENT_NAME_SIDO && item.PARENT_NAME_SIDO.indexOf(keyword) >= 0)
                    || (item.PARENT_NAME_SIGUNGU && item.PARENT_NAME_SIGUNGU.indexOf(keyword) >= 0)) {
                    tableData.push(item);
				}
			});
        }

		return tableData;
	}

    onLocaleSelect(loc_code) {
        var selectedRows = this.gridApi.getSelectedRows();
        if (selectedRows != null && selectedRows.length > 0) {
            this.props.onLocaleSelectHandler(selectedRows[0]);
        }
    }

    onGridReady = params => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    }

    onFirstDataRendered = params => {
        params.api.sizeColumnsToFit();
    }

    rowDataChanged = (params) => {
        this.setState({
            tableSummary: this.state.tableData.length.toLocaleString() + '/' + this.state.loc_infos.length.toLocaleString()
        })

        var column = params.columnApi.getColumn('data.country_rate_share')
        column.colDef.headerName = '총계약내 점유율(' + this.props.country_total[this.state.year].contract_total + '건)'
        params.api.refreshHeader()
    }

    searchData = (e) => {

        var keyword = e.target.value;

        var tableData = this.listSearch(keyword);

        this.setState({
            tableData: tableData,
            keyword: keyword
        });
    }

    defaultColDef = {
        resizable : false,
        editable: false,
        headerClass:'bg-dark text-light',
        suppressMovable: true
    };
    listColumn = [
        {
            headerName: "지역",
            field: "NAME",
            sortable: true,
            minWidth: 130,
            suppressSizeToFit: true,
            cellClass: "text-center",
            cellRenderer: (param) => {
                return rendererLocaleName(param.data);
            }
        },
        {
            headerName: "지사",
            sortable: true,
            minWidth: 40,
            cellClass: "text-center",
            valueGetter: (param) => {
                return param.data.contract[this.state.year].BRANCH
            },
        },
        {
            headerName: "전체",
            sortable: true,
            cellClass: "text-center",
            valueGetter: (param) => {
                return param.data.contract[this.state.year].NURSERY_NEW + param.data.contract[this.state.year].DAYCARE_NEW + param.data.contract[this.state.year].NULL_NEW + param.data.contract[this.state.year].NURSERY_RENEW + param.data.contract[this.state.year].DAYCARE_RENEW + param.data.contract[this.state.year].NULL_RENEW
            },
        },
        {
            headerName: "신규",
            sortable: true,
            cellClass: "text-center",
            valueGetter: (param) => {
                return param.data.contract[this.state.year].TOTAL_NEW
            },
        },
        // {
        //     headerName: "재계약",
        //     field: "data.renew",
        //     sortable: true,
        //     cellClass: "text-center",
        //     valueGetter: (param) => {
        //         return param.data.contract[this.state.year].NURSERY_RENEW + param.data.contract[this.state.year].DAYCARE_RENEW + param.data.contract[this.state.year].NULL_RENEW
        //     },
        // },
        {
            headerName: "재계약",
            sortable: true,
            minWidth: 120,
            cellClass: "text-center",
            valueGetter: (param) => {
                return parseFloat(param.data.contract[this.state.year].RATE_RENEW);
            },
            cellRenderer: (param) => {
                return progressWithGrowthCellRenderer((param.data.contract[this.state.year].TOTAL_RENEW).toLocaleString() + ' / ' + (this.state.year > 2017 ? param.data.contract[this.state.year - 1].TOTAL : 0).toLocaleString(), 
                         param.data.contract[this.state.year].RATE_RENEW,
                         param.data.contract[this.state.year].RATE_RENEW_GROWTH);
            }
        },
        {
            headerName: "지역계약율",
            field: "data.rate_locale",
            sortable: true,
            cellClass: "text-center",
            valueGetter: (param) => {
                return parseFloat(param.data.contract[this.state.year].RATE_LOCALE);
            },
            cellRenderer: (param) => {
                return progressCellRenderer(param.data.contract[this.state.year].RATE_LOCALE + '%', 
                         param.data.contract[this.state.year].RATE_LOCALE);
            }
        },
        {
            headerName: "총계약내 점유율",
            field: "data.country_rate_share",
            sortable: true,
            minWidth: 160,
            cellClass: "text-center",
            valueGetter: (param) => {
                return parseFloat(param.data.contract[this.state.year].TOTAL);
            },
            cellRenderer: (param) => {
                return progressWithGrowthCellRenderer(param.data.contract[this.state.year].TOTAL/* + '/' + this.state.loc_infos.TOTAL_CONTRACT[this.state.year]*/, 
                         param.data.contract[this.state.year].RATE_SHARE,
                         param.data.contract[this.state.year].RATE_GROWTH);
            }
        },
    ];

    render() {
        if (this.state.tableData === null) {
            return (
                <div className="card">
                    <div className="card-body" style={{ height: this.props.height + "px", textAlign: "center", paddingTop: "50px" }}>
                        <span className="dashboard-spinner spinner-xxl"></span>
                    </div>
                </div>
            )
        } else if (this.state.loc_infos.length === 0) {
            return (
                <div className="card">
                    <div className="card-body" style={{ height: this.props.height + "px" }}>
                        No Data
	                </div>
                </div>
            )
        } else {
            return (
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12 mb-2 float-right table-total-summary">
                                {this.state.tableSummary}
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mb-2 float-right">
                                <input className="form-control" type="text" onChange={this.searchData} placeholder="search keyword" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ag-theme-balham" style={{ width: "100%", height: (this.props.height - 62) + "px" }}>
                                <AgGridReact
                                    columnDefs={this.listColumn}
                                    defaultColDef={this.defaultColDef}
                                    rowData={this.state.tableData}
                                    rowHeight={40}
                                    rowSelection="single"
                                    enableCellChangeFlash={true}
                                    onGridReady={this.onGridReady}
                                    onSelectionChanged={this.onLocaleSelect.bind(this)}
                                    onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                                    onRowDataChanged={this.rowDataChanged}
                                >
                                </AgGridReact>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

}


export default LocaleList;